import { ProtocolContentData } from "../../protocol";
export default class BunkerBargeAlongsideData extends ProtocolContentData {
    name;
    freeText;
    commenceOperation;
    typeOfFluid;
    quantity;
    unit;
    constructor(name, commenceOperation, typeOfFluid, quantity, unit, freeText) {
        super();
        this.name = name;
        this.commenceOperation = commenceOperation;
        this.freeText = freeText;
        this.typeOfFluid = typeOfFluid;
        this.quantity = quantity;
        this.unit = unit;
    }
}
//# sourceMappingURL=BunkerBargeAlongsideData.js.map